import { render, staticRenderFns } from "./loginBottom.vue?vue&type=template&id=701ad6b8"
import script from "./loginBottom.vue?vue&type=script&lang=js"
export * from "./loginBottom.vue?vue&type=script&lang=js"
import style0 from "./loginBottom.vue?vue&type=style&index=0&id=701ad6b8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports